import { Injectable } from "@angular/core";
import { ISettings } from "../interfaces/isettings";
import config from "../config.json";

@Injectable()
export class ApplicationSettingsService {

    get apiUrl(): string {
        return config.apiUrl;
    }
}